import React, {Suspense, lazy} from 'react';
import {IObjectStyle, WidgetTypes} from './utils/types';
import ReactDOM from 'react-dom';
import LoadingBlock from './components/LoadingBlock';
import GlobalStateProvider from './contexts/GlobalState';
import {showComponentForLocalDevelopment} from './utils/helpers';

export interface IWidgetTypeId2WidgetClassName {
  widgetTypId: WidgetTypes,
  widgetClassName: WidgetClassNames,
  indexComponent: any,
}

// Used for sharing CSS settings with admin panel without reloading widget
declare global {
  interface Window {
    siwStyles: IObjectStyle[] | undefined
  }
}

// Core RT widget classes for code snippet
const RtWidgetClasses: string[] = [
  'siw-widget',
  'rtw-widget',
];

// Widget unique classes for code snippet
export enum WidgetClassNames {
  OddsComparison = 'siw-widget-odds-comparison',
  OutrightOdds = 'siw-widget-outright-odds',
  MatchCenter = 'siw-widget-match-center',
  LeagueCenter = 'rtw-widget-league-center',
  BettingCalculator = 'rtw-widget-betting-calculator',
  EventListCreator = 'rtw-widget-event-list-creator',
  EventList = 'siw-event-list',
  OfferDisk = 'siw-offer-disk',
}

// Map widget className, widget_type_id to WidgetIndex component
export const rtWidgets: IWidgetTypeId2WidgetClassName[] = [
  {
    widgetTypId: WidgetTypes.TYPE_ODDS_COMPARISON,
    widgetClassName: WidgetClassNames.OddsComparison,
    indexComponent: lazy(() => import('./OddsComparisonIndex'))
  },
  {
    widgetTypId: WidgetTypes.TYPE_OUTRIGHT_ODDS,
    widgetClassName: WidgetClassNames.OutrightOdds,
    indexComponent: lazy(() => import('./OutrightOddsIndex')),
  },
  {
    widgetTypId: WidgetTypes.TYPE_MATCH_CENTER,
    widgetClassName: WidgetClassNames.MatchCenter,
    indexComponent: lazy(() => import('./MatchCenterIndex')),
  },
  {
    widgetTypId: WidgetTypes.TYPE_LIST_CREATOR,
    widgetClassName: WidgetClassNames.EventListCreator,
    indexComponent: lazy(() =>  import('./EventListCreatorIndex')),
  },
  {
    widgetTypId: WidgetTypes.TYPE_LEAGUE_CENTER,
    widgetClassName: WidgetClassNames.LeagueCenter,
    indexComponent: lazy(() => import('./LeagueCenterIndex')),
  },
  {
    widgetTypId: WidgetTypes.TYPE_INTERNAL_EVENT_LIST,
    widgetClassName: WidgetClassNames.EventList,
    indexComponent: lazy(() => import('./EventListIndex')),
  },
  {
    widgetTypId: WidgetTypes.TYPE_BETTING_CALCULATOR,
    widgetClassName: WidgetClassNames.BettingCalculator,
    indexComponent: lazy(() => import('./BettingCalculatorIndex')),
  },
  {
    widgetTypId: WidgetTypes.TYPE_OFFER_DISKS,
    widgetClassName: WidgetClassNames.OfferDisk,
    indexComponent: lazy(() => import('./OfferDiskIndex')),
  },
]

// in pixels
const defaultLoaderHeight = 400;

RtWidgetClasses.forEach((rtWidgetClass: string) => {
  Array.from(document.getElementsByClassName(rtWidgetClass)).forEach(elem => {
    const div: HTMLDivElement = elem as HTMLDivElement;
    const {classList} = div;
  
    rtWidgets.forEach((rtWidget: IWidgetTypeId2WidgetClassName) => {
      if (classList.contains(rtWidget.widgetClassName) && showComponentForLocalDevelopment(rtWidget.widgetClassName)) {
       
       ReactDOM.render((
        <GlobalStateProvider>
          <Suspense fallback={<LoadingBlock height={defaultLoaderHeight} heightMobile={defaultLoaderHeight} isMobile={false}/>}>
            <rtWidget.indexComponent elem={elem}/>
          </Suspense>
        </GlobalStateProvider>
        ), elem);
      }
    })

  });
});